import { render } from "./BookmarkEdit.vue?vue&type=template&id=02888bf4&scoped=true&ts=true"
import script from "./BookmarkEdit.vue?vue&type=script&lang=ts"
export * from "./BookmarkEdit.vue?vue&type=script&lang=ts"

import "./BookmarkEdit.vue?vue&type=style&index=0&id=02888bf4&scoped=true&lang=scss"

import exportComponent from "/home/yjmthu/github/vua/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02888bf4"]])

export default __exports__